import { http } from '../http'
import { URL } from './_constant'

/**
 * 审核-新增
 */
export function API_REVIEW_ADD(data: ApiReview.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 审核-批量新增
 */
export function API_REVIEW_MULTIPLE_ADD(data: ApiReview.MultipleAddParams) {
  return http.post(URL.MULTIPLE_ADD, data)
}
